import { ViDetails, ViResponse } from 'pco-product-service-internal-consumer';
import { videoIdentificationApi } from 'api';

export const sendVideoIdentificationFormData = async (vIFormData: ViDetails): Promise<ViResponse> => {
  return await videoIdentificationApi.saveVideoIdentDetails({
    viDetails: vIFormData,
  });
};
